import { render, staticRenderFns } from "./AnswerItemm.vue?vue&type=template&id=3cb41663&scoped=true&"
import script from "./AnswerItemm.vue?vue&type=script&lang=js&"
export * from "./AnswerItemm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb41663",
  null
  
)

export default component.exports